{
	"imprintTitle": "Mentions légales",
	"termsAndConditionsTitle": "Conditions générales",
	"privacyPolicyTitle": "Politique de confidentialité",
	"openSourceAttributionTitle": "Attribution Open Source"
}
